var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4536 13.5465H13.8877V9.69766H16.4536V7.13177H20.3024V9.69766H22.8683V13.5465H20.3024V16.1124H16.4536V13.5465ZM15.1706 12.2635V10.9806H17.7365V8.41472H19.0195V10.9806H21.5853V12.2635H19.0195V14.8294H17.7365V12.2635H15.1706Z",
    fill: "#4F3085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3779 21.2441C23.6919 21.2441 28 16.936 28 11.6221C28 6.30812 23.6919 2 18.3779 2C13.064 2 8.75587 6.30812 8.75587 11.6221C8.75587 14.0481 9.65393 16.265 11.1357 17.9572L9.92142 19.1715L8.18496 19.0939L4 23.2789L6.72112 26L10.8727 21.849L10.8702 20.0369L12.0428 18.8643C13.7948 20.4016 16.0471 21.2476 18.3779 21.2441ZM18.3779 19.9612C22.9837 19.9612 26.7171 16.2278 26.7171 11.6221C26.7171 7.0163 22.9837 3.28294 18.3779 3.28294C13.7722 3.28294 10.0388 7.0163 10.0388 11.6221C10.0388 16.2278 13.7722 19.9612 18.3779 19.9612ZM6.72112 24.1859L5.81408 23.2789L8.69172 20.4006L9.58785 20.441L9.58914 21.3179L6.72112 24.1859Z",
    fill: "#4F3085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.53afccbafa641c33dbb251536fe04fdb.svg";
export { ForwardRef as ReactComponent };